import {DataFetcher} from '@aboutyou/data-fetcher';
import {SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {NavigationDataError} from './NavigationDataError';
import {OffcanvasCategoryTreeView} from './OffcanvasCategoryTreeView';
import {useRequestCategoryTree} from './useRequestDrawerNavigation';

export const OffcanvasCategoryTree = (props: {
  onClick?: () => void;
  onCategoryClick?: VoidFunction;
}) => {
  const request = useRequestCategoryTree();

  return (
    <DataFetcher
      request={request}
      Loading={SkeletonList}
      Error={() => <NavigationDataError />}
      View={OffcanvasCategoryTreeView}
      viewProps={{isTransitioning: request.isStale, ...props}}
    />
  );
};

const SkeletonList = () => {
  return (
    <SkeletonWrapper>
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
      <StyledSkeletonBlock $height="60px" disableSpaceBelow />
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4px;
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  border-radius: 8px;
`;
